import ButtonBase from '@mui/material/ButtonBase';
import { ButtonBaseProps } from '@mui/material';
import clsx from 'clsx';

import styles from './styles.module.scss';

type InputProps = ButtonBaseProps & {
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
};

export const TextButton = ({
  disabled = false,
  className,
  children,
  onClick,
  ...props
}: InputProps) => {
  return (
    <ButtonBase
      disabled={disabled}
      onClick={onClick}
      classes={{
        root: clsx(styles.root, className),
      }}
      {...props}
    >
      {children}
    </ButtonBase>
  );
};
